import React from 'react';
import { Helmet } from 'react-helmet';
import { localBusinessSchema } from '../lib/structuredData';
interface SEOProps {
  title?: string;
  description?: string;
  keywords?: string;
  canonical?: string;
  ogImage?: string;
  ogType?: 'website' | 'article' | 'profile';
  jsonLd?: object | object[];
  noindex?: boolean;
}
export const SEO: React.FC<SEOProps> = ({
  title = 'Online gevonden worden in Noord-Holland Noord | Noord Digital',
  description = 'Noord Digital zorgt dat ondernemers in Noord-Holland Noord online gevonden worden en professioneel overkomen. Websites, vormgeving, hosting, e-mail en SEO uit Oudkarspel.',
  keywords = 'online gevonden worden, website laten maken Noord-Holland, huisstijl laten maken, vormgeving Dijk en Waard, seo Noord-Holland Noord, webdesign Oudkarspel',
  canonical = 'https://noorddigital.nl',
  ogImage = 'https://noorddigital.nl/og-image.jpg',
  ogType = 'website',
  jsonLd,
  noindex = false
}) => {
  // De bedrijfsgegevens (ProfessionalService) staan op elke pagina, zodat
  // naam, adres en nummer overal identiek zijn. Geeft een pagina het schema
  // zelf al mee, dan tonen we het niet dubbel.
  const pageSchemas = jsonLd ? Array.isArray(jsonLd) ? jsonLd : [jsonLd] : [];
  const schemas = [localBusinessSchema, ...pageSchemas.filter(schema => schema !== localBusinessSchema)];
  return <Helmet data-id="element-745" data-mp="1ukyp4hmtnstz">
      {/* Favicon */}
      <link rel="icon" type="image/svg+xml" href="https://cdn.magicpatterns.com/uploads/mue3TYJ7nvuB2eSYNuEqcF/Logo_favicon.svg" data-id="element-746" data-mp="1qjd3a6sb847n" />
      <link rel="apple-touch-icon" href="https://cdn.magicpatterns.com/uploads/mue3TYJ7nvuB2eSYNuEqcF/Logo_favicon.svg" data-id="element-747" data-mp="1lrvdmevqlq1z" />

      {/* Primary Meta Tags */}
      <title data-id="element-748" data-mp="1grh7j2dp4q6l">{title}</title>
      <meta name="title" content={title} data-id="element-749" data-mp="1bv8r7lnriqxu" />
      <meta name="description" content={description} data-id="element-750" data-mp="1bwjyhvgf2gtp" />
      <meta name="keywords" content={keywords} data-id="element-751" data-mp="16w5queiq98w7" />
      <meta name="author" content="Noord Digital" data-id="element-752" data-mp="16uungft7235m" />
      <meta name="application-name" content="Noord Digital" data-id="element-753" data-mp="12tsidicliwvq" />
      <link rel="canonical" href={canonical} data-id="element-754" data-mp="12wer3lb83ifj" />
      <link rel="alternate" hrefLang="nl-nl" href={canonical} data-id="element-755" data-mp="s7vuggeov0os" />
      <link rel="alternate" hrefLang="x-default" href={canonical} data-id="element-756" data-mp="x80e2faw8bj8" />

      {/* Crawling */}
      <meta name="robots" content={noindex ? 'noindex, follow' : 'index, follow, max-image-preview:large, max-snippet:-1'} data-id="element-757" data-mp="j88s9se4xquo" />
      <meta name="geo.region" content="NL-NH" data-id="element-758" data-mp="o6tufxcy6klr" />
      <meta name="geo.placename" content="Oudkarspel" data-id="element-759" data-mp="o7lp95yq0eaz" />

      {/* Open Graph / Facebook */}
      <meta property="og:type" content={ogType} data-id="element-760" data-mp="1bxfzdfrnnorj" />
      <meta property="og:site_name" content="Noord Digital" data-id="element-761" data-mp="1fz1aavkmpsz3" />
      <meta property="og:locale" content="nl_NL" data-id="element-762" data-mp="1g0m42iz4d7vw" />
      <meta property="og:url" content={canonical} data-id="element-763" data-mp="127wgia3xzuwo" />
      <meta property="og:title" content={title} data-id="element-764" data-mp="1250h0hcg4y64" />
      <meta property="og:description" content={description} data-id="element-765" data-mp="175el5oaxfnyv" />
      <meta property="og:image" content={ogImage} data-id="element-766" data-mp="1uvsbnadv5erc" />
      <meta property="og:image:alt" content={title} data-id="element-767" data-mp="1uv0gu1s3bl24" />

      {/* Twitter */}
      <meta property="twitter:card" content="summary_large_image" data-id="element-768" data-mp="1zmquagmbqoxr" />
      <meta property="twitter:url" content={canonical} data-id="element-769" data-mp="291atgscn9m0t" />
      <meta property="twitter:title" content={title} data-id="element-770" data-mp="28zrbmxbcb2wx" />
      <meta property="twitter:description" content={description} data-id="element-771" data-mp="24zyx83z9m2jn" />
      <meta property="twitter:image" content={ogImage} data-id="element-772" data-mp="24xmis0spuabc" />

      {/* Structured data */}
      {schemas.map((schema, index) => <script key={index} type="application/ld+json" data-id="element-773" data-mp="2ds0w3xtorart" data-mpi={index}>
          {JSON.stringify(schema)}
        </script>)}

      {/* Language */}
      <html lang="nl" data-id="element-774" data-mp="1q1oji9nhwpuw" />
    </Helmet>;
};